<template>
  <ons-page id="edit-profile">
    <app-bar :title="$t('edit_profile.title')" :enable-home="false" />
    <v-ons-progress-bar indeterminate class="app-bar-progress" v-show="loading"></v-ons-progress-bar>
    <form action="" class="form">
      <div class="justify-row">
        <div class="edit-avatar">
          <input type="file" id="avatar-input" @change="onAvatarChange" :disabled="isOffline" />
          <label class="por-rt" for="avatar-input">
            <img-with-placeholder :src="constants.phImg70x70" :data-src="sizeImg(currentUser.avatar_base_url, 70, 70)" :alt="currentUser.avatar.alt_text" /><span>{{ $t("edit_profile.edit") }}</span>
          </label>
        </div>
        <div class="main-item">
          <ul class="no-bullet">
            <li class="por-rm">
              <label for="name">
                <input class="form-input no-border" type="text" id="name" :placeholder="$t('edit_profile.name')"
                  v-model="name" @input="debouncedSaveUserUpdate" :disabled="isOffline"
                >
              </label>
            </li>
            <li class="por-rm"
              v-for="error in errors.name || []"
            ><div class="message-error">{{ error }}</div></li>
          </ul>
        </div>
      </div>
      <ul class="no-bullet">
        <li class="account-gap">
          <label for="bio">{{ $t("edit_profile.bio") }}</label>
        </li>
        <li class="account-row bd-bottom por-rm">
          <textarea class="form-textarea no-border" name="bio" id="bio" cols="30" rows="4"
            v-model="bio" @input="debouncedSaveUserUpdate" :disabled="isOffline"
          ></textarea>
        </li>
        <li class="por-rm"
          v-for="error in errors.bio || []"
        ><div class="message-error">{{ error }}</div></li>
      </ul>
    </form>
    <v-ons-toast :visible="shouldShowGoOnlineToast" animation="ascend">
      {{ $t("messages.go_online_to_edit_profile") }}
      <button @click="goOnline">{{ $t("ui.go_online") }}</button>
    </v-ons-toast>
  </ons-page>
</template>

<script>
import { debounce } from "debounce";
import AppBar from '@/components/AppBar.vue';

export default {
  name: 'profile-edit',
  components: {
    'app-bar': AppBar
  },

  data() {
    return {
      name: null,
      bio: null,
      loading: false,
      errors: {},
    };
  },

  methods: {
    saveUserUpdate() {
      this.errors = {};
      let that = this;
      if (!this.name) {
        this.errors.name = [this.$t("edit_profile.errors.name_empty")];
        return;
      }
      this.loading = true
      let params = { name: this.name, bio: this.bio };
      this.currentUser.update(params)
        .then(() => {
          this.$ons.notification.toast(this.$t("messages.update_saved"), { timeout: 1500, animation: 'fall' });
        }).catch((error) => {
          if (error.response && error.response.status === 422) {
            for (var key in error.response.data.errors) {
              that.errors[key] = error.response.data.errors[key];
            }
            that.showCheckErrorsToast();
          } else {
            console.log(error);
            that.showSomethingWrongToast();
          }
        }).finally(() => {
          this.loading = false;
        });
    },

    onAvatarChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) { return; }
      let file = files[0];

      this.errors = {};
      let that = this;
      this.loading = true
      this.currentUser.updateAvatar(file)
        .then(() => {
          this.$ons.notification.toast(this.$t("messages.update_saved"), { timeout: 1500, animation: 'fall' });
        }).catch((error) => {
          if (error.response && error.response.status === 422) {
            for (var key in error.response.data.errors) {
              that.errors[key] = error.response.data.errors[key];
            }
            that.showCheckErrorsToast();
          } else {
            console.log(error);
            that.showSomethingWrongToast();
          }
        }).finally(() => {
          this.loading = false;
        });
    },
  },

  created() {
    this.name = this.currentUser.name;
    this.bio = this.currentUser.bio;
    this.debouncedSaveUserUpdate = debounce(() => {
      this.saveUserUpdate();
    }, 1000);
  },
};
</script>
